import type { FormData } from "../types";
interface LessonInfoSectionProps {
  formData: FormData;
  subjects: string[];
  classes: string[];
  onFormChange: (field: keyof FormData, value: any) => void;
}

export function LessonInfoSection({
  formData,
  subjects,
  classes,
  onFormChange,
}: LessonInfoSectionProps) {
  return (
    <>
      <div>
        <label
          className="block text-sm font-medium mb-2"
          style={{ color: "var(--text-primary)" }}
        >
          Título da Aula
        </label>
        <input
          type="text"
          value={formData.title}
          onChange={(e) => onFormChange("title", e.target.value)}
          className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 transition bg-(--input-bg)"
          style={{
            borderColor: "var(--border-color)",
            color: "var(--text-primary)",
          }}
          placeholder="Ex: Introdução às Frações"
        />
      </div>

      <div>
        <label
          className="block text-sm font-medium mb-2"
          style={{ color: "var(--text-primary)" }}
        >
          Matéria *
        </label>
        <select
          value={formData.subject}
          onChange={(e) => onFormChange("subject", e.target.value)}
          className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 transition bg-(--input-bg)"
          style={{
            borderColor: "var(--border-color)",
            color: "var(--text-primary)",
          }}
          required
        >
          <option value="">Selecione uma matéria</option>
          {subjects.map((subject) => (
            <option key={subject} value={subject}>
              {subject}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label
          className="block text-sm font-medium mb-2"
          style={{ color: "var(--text-primary)" }}
        >
          Série/Turma *
        </label>
        <select
          value={formData.grade}
          onChange={(e) => onFormChange("grade", e.target.value)}
          className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 transition bg-(--input-bg)"
          style={{
            borderColor: "var(--border-color)",
            color: "var(--text-primary)",
          }}
          required
        >
          <option value="">Selecione uma série</option>
          {classes.map((grade) => (
            <option key={grade} value={grade}>
              {grade}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label
          className="block text-sm font-medium mb-2"
          style={{ color: "var(--text-primary)" }}
        >
          Duração *
        </label>
        <select
          value={formData.duration}
          onChange={(e) => onFormChange("duration", e.target.value)}
          className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 transition bg-(--input-bg)"
          style={{
            borderColor: "var(--border-color)",
            color: "var(--text-primary)",
          }}
        >
          <option value="45">45 minutos</option>
          <option value="60">60 minutos</option>
          <option value="90">90 minutos</option>
          <option value="120">120 minutos</option>
        </select>
      </div>

      <div className="md:col-span-2">
        <label
          className="block text-sm font-medium mb-2"
          style={{ color: "var(--text-primary)" }}
        >
          Tópico Principal *
        </label>
        <input
          type="text"
          value={formData.topic}
          onChange={(e) => onFormChange("topic", e.target.value)}
          className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 transition bg-(--input-bg)"
          style={{
            borderColor: "var(--border-color)",
            color: "var(--text-primary)",
          }}
          placeholder="Ex: Frações equivalentes, Equações de 1º grau..."
          required
        />
      </div>
    </>
  );
}
